import { Container, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { AuthorizedCloudReseller } from "../../helpers/constant/imageUrl";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import { WhatsApp, YouTube } from "@mui/icons-material";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveIndex, show } from "../../redux/SideBarSlice";
import { setNav_Item } from "../../redux/NavBarSlice";
import "./footer.scss";
import { useState } from "react";
import { setActiveMenu, toggleMobileNavbar } from "../../redux/MobileSideBar";

const FooterTemplate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const message = encodeURIComponent("Hii");
  const [showFox, setShowFox] = useState(false);
  const isMobile = useMediaQuery("(max-width: 899px)");
  const location = useLocation();


  return (
    <div className="footer">
      <Container className="container">
        <Grid container justifyContent="space-between">
          {/* Logo Section */}
          <Grid
            size={{ xs: 12, md: 4 }}
            display={"flex"}
            flexDirection={"column"}
            overflow={"hidden"}
            // border={"1px solid white"}
            marginBottom={{ xs: "24px", md: "auto" }}
          >
            <div className="white-util-logo">
               <img  loading="lazy"
                src="/images/Whiteanimated-gif.gif"
                 
                alt="Whiteanimated"
              />
            </div>
            <div className="mt-6">
              <div className="summit-partner-logo">
                 <img  loading="lazy"
                  src="/images/summitpartner-logo.webp"
                   
                  alt="summitpartner-logo"
                />
              </div>
              <div className="summit-partner-logo">
                 <img  loading="lazy"
                  src={AuthorizedCloudReseller}
                   
                  alt="AuthorizedCloudReseller"
                />
              </div>
            </div>
          </Grid>

          {/* Links Sections */}
          <Grid size={{ xs: 6, md: 1.5 }}>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>

              <li>
                <a
                  href="null"
                  onClick={(e) => {
                    e.preventDefault();
                    // dispatch(show("aboutus"));
                    dispatch(setNav_Item("aboutus"));
                    dispatch(setActiveIndex(null));
                    if (isMobile) {
                      dispatch(toggleMobileNavbar());
                      dispatch(setActiveMenu("aboutus"));
                    } else {
                      dispatch(show("aboutus"));
                    }
                  }}
                >
                  About Us
                </a>
              </li>
              <li>
                <a href="/aboutus/partnerwithus">Partner with us</a>
              </li>
              <li>
                <a href="/totalcards">Case Studies</a>
              </li>
              {isMobile && (
                <li>

                  <NavLink
                    to="/aboutus/our-impact"
                    state={{ selectCategory: "2" }}
                  >
                    Blogs
                  </NavLink>
                </li>
              )}

              {isMobile && (
                <>
                  <li>{/* <a href=""></a> */}</li>
                  <li>
                    <a href="/privacypolicy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/cookies">Cookies</a>
                  </li>
                  <li>
                    <a href="/termsandconditions">Terms & Conditions</a>
                  </li>
                </>
              )}
            </ul>
          </Grid>

          <Grid size={{ xs: 4.5, md: 1.2 }}>
            <ul>
              <li>
                <NavLink
                  onClick={(e) => {
                    e.preventDefault();
                    // dispatch(show("services"));
                    dispatch(setNav_Item("services"));
                    if (isMobile) {
                      dispatch(toggleMobileNavbar());
                      dispatch(setActiveMenu("services"));
                    } else {
                      dispatch(show("services"));
                    }
                  }}
                >
                  Services
                </NavLink>
              </li>
              <li>
                <NavLink
                  onClick={(e) => {
                    e.preventDefault();
                    // dispatch(show("solutions"));
                    dispatch(setNav_Item("solutions"));
                    if (isMobile) {
                      dispatch(toggleMobileNavbar());
                      dispatch(setActiveMenu("solutions"));
                    } else {
                      dispatch(show("solutions"));
                    }
                  }}
                >
                  Solutions
                </NavLink>
              </li>
              <li>
                <a
                  href="null"
                  onClick={(e) => {
                    e.preventDefault();
                    // dispatch(show("industries"));
                    dispatch(setActiveIndex(null));
                    dispatch(setNav_Item("industries"));
                    if (isMobile) {
                      dispatch(toggleMobileNavbar());
                      dispatch(setActiveMenu("industries"));
                    } else {
                      dispatch(show("industries"));
                    }
                  }}
                >
                  Industries
                </a>
              </li>

              <li>
                <a
                  href="null"
                  onClick={(e) => {
                    e.preventDefault();
                    // dispatch(show("products"));
                    dispatch(setNav_Item("products"));
                    if (isMobile) {
                      dispatch(toggleMobileNavbar());
                      dispatch(setActiveMenu("product"));
                    } else {
                      dispatch(show("products"));
                    }
                  }}
                >
                  Products
                </a>
              </li>

              {isMobile && (
                <>
                  <li>
                    <a href="/contactus">Contact Us</a>
                  </li>
                  <li>
                    <a href="/certifications">Certifications</a>
                  </li>

                  <li>
                    <a href="/careers">Careers</a>
                  </li>
                </>
              )}
            </ul>
          </Grid>

          <Grid size={{ xs: 9, md: 2 }} marginTop={{ xs: "-50px", md: "0" }}>
            <ul>
              {!isMobile && (
                <>
                  <li>
                    <a href="/contactus">Contact Us</a>
                  </li>
                  <li>
                    <a href="/certifications">Certifications</a>
                  </li>
                  <li>
                    <NavLink
                      to="/aboutus/our-impact"
                      state={{ selectCategory: "2" }}
                    >
                      Blogs
                    </NavLink>
                  </li>
                  <li>
                    <a href="/careers">Careers</a>
                  </li>
                </>
              )}
            </ul>
          </Grid>

          {/* Contact Info */}
          <Grid
            size={{ xs: 12, md: 2.5 }}
            marginTop={{ xs: "20px", md: "auto" }}
          >
            <ul className="contact">
              <li>
                <a href="">
                  <CallIcon className="mr-4" /> +91 99107 70310
                </a>
              </li>
              <li className="mt-2">
                <a href="mailto:marketing@utilitarianlabs.com">
                  <EmailIcon className="mr-4" /> marketing@utilitarianlabs.com
                </a>
              </li>
            </ul>
            <h5>Follow us on</h5>
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/company/utilitarianlabs/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon className="linkdin" />
              </a>
              <a
                href="https://www.instagram.com/utilitarian_labs?igsh=cmRvd2R4NG5nZHZq"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon className="insta" />
              </a>
              <a
                href={`https://wa.me/919910770310?text=${message}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <WhatsApp className="whatsapp" />
              </a>
              <a
                href="https://www.youtube.com/@UtilitarianLabs2015"
                target="_blank"
                rel="noopener noreferrer"
              >
                <YouTube className="ytb" />
              </a>
              
            </div>
          </Grid>
        </Grid>

        {/* Copy Right */}
        <div className="footer_bottom">
          <div className="copy-right">
            Copyright &copy; 2025 Utilitarian Labs Pvt. Ltd. All Rights
            Reserved.
          </div>
          <div className="footer_terms">
            <li>
              <a href="/privacypolicy">Privacy Policy</a>
            </li>
            <li>
              <a href="/cookies">Cookies</a>
            </li>
            <li>
              <a href="/termsandconditions">Terms & Conditions</a>
            </li>
          </div>
        </div>
      </Container>

      <div className="floating-fox-container">
        {/* FOX */}
        <div className="animated-fox-box" onMouseEnter={() => setShowFox(true)}>
           <img  loading="lazy"
            src="/images/rianlogo2.gif"
            alt="fox-bot"
            onAnimationIteration={() => {
              // fox cycle restarted → hide boxes
              setShowFox(false);
            }}
          />
        </div>

        {/* QUERY BOX */}
        <div
          className={`query-box ${showFox ? "show" : ""}`}
          onMouseEnter={() => setShowFox(true)}
          onMouseLeave={() => setShowFox(false)}
        >
          <div className="talk-box" onClick={() => navigate("/Contactform")}>
            Talk to an Expert
          </div>
          <div className="talk-box2" onClick={() => navigate("/talktoexpert")}>
            Schedule a Demo
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterTemplate;
